import { memo, useMemo } from 'react';

import { BacktesterPnlReportRow } from '../../../../../providers/backtesting/api/backtester-config-api.types';

import { buildLineSeriesData, getRowFieldNumber } from './helpers';
import { MarketDataChart } from './market-data-chart';

interface PerpSpreadChartProps {
  reports: BacktesterPnlReportRow[];
}

const FWD_SPREAD_SERIES = [
  { key: 'fwd_1W', label: 'Fwd 1W' },
  { key: 'fwd_2W', label: 'Fwd 2W' },
  { key: 'fwd_1M', label: 'Fwd 1M' },
  { key: 'fwd_2M', label: 'Fwd 2M' },
  { key: 'fwd_3M', label: 'Fwd 3M' },
] as const;

export const PerpSpreadChart = memo(({ reports }: PerpSpreadChartProps) => {
  const seriesConfigs = useMemo(
    () =>
      FWD_SPREAD_SERIES.map(({ key, label }) => ({
        key,
        label,
        data: buildLineSeriesData(reports, (row) => {
          const forwardValue = getRowFieldNumber(row, key);
          if (forwardValue == null) return null;
          return forwardValue - row.perp;
        }),
      })),
    [reports],
  );

  return (
    <MarketDataChart
      cardKey="market-data-perp-spread-chart"
      title="Perp Spread"
      seriesConfigs={seriesConfigs}
      maximumFractionDigits={0}
      minMove={1}
    />
  );
});

PerpSpreadChart.displayName = 'PerpSpreadChart';
